import { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";

const STATS = [
  { value: 200, suffix: "+", label: "Brands scaled" },
  { value: 5, suffix: " yrs", label: "Of expertise" },
  { value: 12, suffix: "x", label: "Avg. return on ad spend" },
  { value: 48, suffix: "M+", label: "Revenue driven (₹)" },
];

const Counter = ({ value, suffix }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!inView) return;
    let start = 0;
    const duration = 1600;
    const startTime = performance.now();
    const tick = (now) => {
      const progress = Math.min((now - startTime) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setCount(Math.floor(eased * value));
      if (progress < 1) requestAnimationFrame(tick);
      else setCount(value);
    };
    requestAnimationFrame(tick);
    return () => { start = value; };
  }, [inView, value]);

  return (
    <span ref={ref}>
      {count}
      {suffix}
    </span>
  );
};

export const Stats = () => {
  return (
    <section data-testid="stats" className="mx-auto max-w-[90rem] px-6 py-20 md:px-12">
      <div className="grid grid-cols-2 gap-8 md:grid-cols-4">
        {STATS.map((s, i) => (
          <motion.div
            key={s.label}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: i * 0.08 }}
            data-testid={`stat-${i}`}
            className="border-l border-white/10 pl-5"
          >
            <div className="font-display text-4xl font-extrabold tracking-tighter text-white md:text-6xl">
              <Counter value={s.value} suffix={s.suffix} />
            </div>
            <p className="mt-2 font-mono text-xs uppercase tracking-[0.15em] text-white/65">
              {s.label}
            </p>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Stats;
